import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { ServiceResponseData } from "../ServiceResponseData";
import { CreateClientProfileReqData } from "./CreateClientProfileReqData";

const ENDPOINT = "/usermanagement/profiles";

export class CreateClientProfileCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    clientProfileReqData: CreateClientProfileReqData;

    constructor(clientProfileReqData: CreateClientProfileReqData) {
        super();
        this.clientProfileReqData = clientProfileReqData;
    }

    public async execute(): Promise<ServiceResponseData> {
        var res = await this.executeCommand(this.clientProfileReqData);
        return new ServiceResponseData(res);
    }
}
